import Highcharts from 'highcharts';
import highchartsTimeline from 'highcharts/modules/timeline';
import highchartsAccessibilityInit from 'highcharts/modules/accessibility';
import $ from 'jquery';

highchartsTimeline(Highcharts);
highchartsAccessibilityInit(Highcharts);

const timeline0Container = document.getElementById('jo-timeline-container-0');
const timeline0Dataset = JSON.parse(timeline0Container.getAttribute('data-dates'));
const timeline1Container = document.getElementById('jo-timeline-container-1');
const timeline1Dataset = JSON.parse(timeline1Container.getAttribute('data-dates'));
const timeline2Container = document.getElementById('jo-timeline-container-2');
const timeline2Dataset = JSON.parse(timeline2Container.getAttribute('data-dates'));
const timeline3Container = document.getElementById('jo-timeline-container-3');
const timeline3Dataset = JSON.parse(timeline3Container.getAttribute('data-dates'));
const filterBtns = document.querySelectorAll('.timeline-filter');
let filterList = [];

function filterTimelineChart(dateArr) {
  return dateArr.filter((item) => filterList.includes(item.categoryCode));
}

function buildChartData(dataset) {
  const finalData = [];
  dataset.forEach((time) => {
    finalData.push({
      name: `<strong>${time.date}</strong>`,
      label: `<em>${time.category}</em> <br/> ${time.description}<br /><a class="time-link" tabindex="0" href="${time.url}">${time.urlText}</a>`,
      color: time.color,
      accessibility: {
        description: `<em>${time.category}</em> <br/> ${time.description}`,
      },
    });
  });
  return finalData;
}

function getData(chartNum) {
  const chartData = {
    dataSet: {},
    description: '',
  };

  if (chartNum === 'zero') {
    chartData.dataSet = timeline0Dataset;
    chartData.description = 'Joint office timeline for the year 2021';
  } if (chartNum === 'one') {
    chartData.dataSet = timeline1Dataset;
    chartData.description = 'Joint office timeline for the year 2022';
  } if (chartNum === 'two') {
    chartData.dataSet = timeline2Dataset;
    chartData.description = 'Joint office timeline for the year 2023';
  } if (chartNum === 'three') {
    chartData.dataSet = timeline3Dataset;
    chartData.description = 'Joint office timeline for the year 2024';
  }
  return chartData;
}

function getOptions(chart, dataType) {
  const dataByYear = getData(chart);
  const fullDataSet = dataByYear.dataSet;
  // on load, use all data. on filter, use filtered dataset
  const filteredDataSet = dataType === 'all' ? fullDataSet : filterTimelineChart(fullDataSet);
  // formats chart labels as required by highcharts
  const chartData = buildChartData(filteredDataSet);
  const { chartDescription } = dataByYear;
  // sets height to make even spaced lines depending on number
  // of data points, if chart is blank after filter, height is 50px
  const chartHeight = filteredDataSet.length >= 1 ? filteredDataSet.length * 65 : 50;
  return {
    chart: {
      type: 'timeline',
      inverted: true,
      animation: false,
      height: chartHeight,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: chartDescription,
      // allows the chart title to be read for screen readers but
      // not appear visually as a description is already above the chart
      style: {
        display: 'none',
      },
    },
    xAxis: {
      visible: false,
    },
    yAxis: {
      visible: false,
    },
    tooltip: {
      enabled: false,
    },
    series: [{
      type: 'timeline',
      useHTML: true,
      dataLabels: {
        distance: 275,
        padding: 10,
        connectorWidth: 2,
        alternate: true,
        style: {
          textOverflow: 'ellipsis',
          fontFamily: 'Montserrat',
          fontSize: '0.85rem',
          lineHeight: '20px',
          borderWidth: 2,
          borderColor: '#AAA',
        },
      },
      data: chartData,
    }],
  };
}
function updateMobileTimeline() {
  const timelineCards = document.querySelectorAll('.timeline-card');
  timelineCards.forEach((card) => {
    // eslint-disable-next-line no-param-reassign
    card.style.display = 'none';
    filterList.forEach((category) => {
      if (card.getAttribute('data-category').includes(category)) {
        // eslint-disable-next-line no-param-reassign
        card.style.display = 'block';
      }
    });
  });
}

function updateAllCharts() {
  // charts have to be destroyed before re-built else they will not render properly
  Highcharts.charts.forEach((chart) => {
    if (chart) {
      chart.destroy();
    }
  });
  Highcharts.chart('jo-timeline-container-0', getOptions('zero', 'updated'));
  Highcharts.chart('jo-timeline-container-1', getOptions('one', 'updated'));
  Highcharts.chart('jo-timeline-container-2', getOptions('two', 'updated'));
  Highcharts.chart('jo-timeline-container-3', getOptions('three', 'updated'));

  updateMobileTimeline();
}

function filterTimeline() {
  filterList = [];
  filterBtns.forEach((elem) => {
    if (elem.checked) {
      filterList.push(elem.value);
    }
  });
}

// eslint-disable-next-line func-names
filterBtns.forEach((btn) => btn.addEventListener('change', function () {
  this.toggleAttribute('checked');
  filterTimeline();
  updateAllCharts();
}));

function setActiveBtn() {
  const scroll = $(window).scrollTop();
  // if at top of page reset default active button
  if (scroll === 0) {
    $('.timeline-control.active-timeline').removeClass('active-timeline');
    $('.timeline-control').first().addClass('active-timeline');
  } else {
    // or check where on page and set active button on that
    // eslint-disable-next-line func-names
    $('.timeline-control').each(function () {
      const currentSection = $(this).data('target');
      const currentSectionId = $(`#${currentSection}`);
      const topOfSection = currentSectionId.position().top;
      const heightOfSection = topOfSection + currentSectionId.height();
      if (topOfSection <= scroll && topOfSection + heightOfSection > scroll) {
        $('.timeline-control.active-timeline').removeClass('active-timeline');
        $(this).addClass('active-timeline');
      }
    });
  }
}

window.addEventListener('load', () => {
  Highcharts.chart('jo-timeline-container-0', getOptions('zero', 'all'));
  Highcharts.chart('jo-timeline-container-1', getOptions('one', 'all'));
  Highcharts.chart('jo-timeline-container-2', getOptions('two', 'all'));
  Highcharts.chart('jo-timeline-container-3', getOptions('three', 'all'));

  setActiveBtn();
  $(window).scroll(() => {
    setActiveBtn();
  });
  $(window).resize(() => {
    setActiveBtn();
  });
});
